"use client";
import { px } from "../units-converters/px.mjs";
//#region packages/@mantine/core/src/core/utils/get-breakpoint-value/get-breakpoint-value.ts
function getBreakpointValue(breakpoint, breakpoints) {
	if (breakpoint in breakpoints) return px(breakpoints[breakpoint]);
	return px(breakpoint);
}
//#endregion
export { getBreakpointValue };

//# sourceMappingURL=get-breakpoint-value.mjs.map